const api = [
  {
    name: 'selectOnAreaLevel',
    desc: '获取地区地址(省)',
    method: 'GET',
    path: '/area/china/selectOnAreaLevel'
  },
  {
    name: 'selectOnParentCode',
    desc: '获取地区地址(市)',
    method: 'GET',
    path: '/area/china/selectOnParentCode'
  }
]

export default {
  BASE_URL: '',
  NAMESPACE: 'area',
  api
}



// WEBPACK FOOTER //
// ./src/api/apis/self/secondhand/area.js